import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { setupAuthFetch } from "./utils/setupAuthFetch";

// 🔹 Analytics (PostHog)
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

// -------------------------------------------
// 🧠 Initialize PostHog only if keys are defined
// -------------------------------------------
if (process.env.REACT_APP_POSTHOG_KEY && process.env.REACT_APP_POSTHOG_HOST) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    autocapture: true,
    capture_pageview: true,
    enable_recording: process.env.NODE_ENV === "production", // record only in prod
  });
} else {
  console.warn("⚠️ PostHog not initialized — missing env vars");
}

setupAuthFetch();

// -------------------------------------------
// 🖱️ Optional: custom glowing cursor handler
// -------------------------------------------
document.addEventListener("mousemove", (e) => {
  const cursor = document.querySelector(".custom-cursor");
  if (cursor) {
    cursor.style.left = `${e.clientX}px`;
    cursor.style.top = `${e.clientY}px`;
  }
});

// -------------------------------------------
// 🧩 Mount React app
// -------------------------------------------
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // Remove StrictMode during UI animation dev to avoid double renders
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
);
